const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "ReportID",
		label: "编号",
		columnwidth: 120,
	},
	{
		prop: "ReportCusName",
		label: "报量经销商",
		columnwidth: 220,
	},
	{
		prop: "BuyCusName",
		label: "订货经销商",
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 120,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 125,
	}
];
export default headerData;